<template>
  <Modal title="编辑" v-model="showIs" @on-visible-change="onVisibleChange">
    <Form ref="form" class="form" :model="formData" :rules="formRule" :label-width="80">
      <Row>
        <i-col :span="22">
          <Form-item label="物流名称" prop="logicName">
            <Input v-model="formData.logicName"/>
          </Form-item>
        </i-col>
        <i-col :span="22">
          <Form-item label="物流单号" prop="logicNumber">
            <Input v-model="formData.logicNumber"/>
          </Form-item>
        </i-col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="showIs=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingEdit" @click="edit">保存</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'LogicModal',
    props: {
      itemId: Number,
      value: {
        type: Boolean,
        default: false
      },
      logicName: String,
      logicNumber: String,
    },
    data() {
      return {
        showIs: this.value,
        formRule: {},
        searchLoading: false,
        loadingEdit: false,
        formData: {
          id: null,
          logicName: '',
          logicNumber: '',
        },
      }
    },
    mounted: function () {

    },
    created: function () {

    },
    methods: {
      onVisibleChange(val) {
        let self = this
        if (!val) {
          self.$emit('on-close')
        }
      },
      edit() {
        let self = this
        self.loadingEdit = true
        self.showIs = true
        let path = '/courseEx/logic'
        self.$http.post(path, self.formData).then(function (res) {
          self.showIs = false
          self.$Message.success('提交成功!')
          self.$emit('on-edit-success')
          self.clearItem()
          self.loadingEdit = false
        })
      },
      clearItem() {
        let self = this
        self.formData.id = ''
        self.formData.logicNumber = ''
        self.formData.logicName = ''
        self.showIs = false
      },
    },
    watch: {
      value(val) {
        let self = this
        if (val) {
          self.showIs = true
        } else {
          this.clearItem()
        }
      },
      itemId(val) {
        let self = this
        if (val) {
          self.formData.id = val
        }
        self.$emit('on-edit-clearid')
      },
      logicName(val) {
        let self = this
        if (val) {
          self.formData.logicName = val
        }
        self.$emit('on-edit-clearid')
      },
      logicNumber(val) {
        let self = this
        if (val) {
          self.formData.logicNumber = val
        }
        self.$emit('on-edit-clearid')
      },
    }
  }
</script>



// WEBPACK FOOTER //
// LogicModal.vue?3fcc5f68